import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=5e2aad87&scoped=true&"
import script from "./Faqs.vue?vue&type=script&lang=js&"
export * from "./Faqs.vue?vue&type=script&lang=js&"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=5e2aad87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2aad87",
  null
  
)

export default component.exports